// Central content + asset references for Cretexa

export const NAV_LINKS = [
  { label: "Work", href: "#work" },
  { label: "Services", href: "#services" },
  { label: "Manifesto", href: "#manifesto" },
  { label: "FAQ", href: "#faq" },
  { label: "Contact", href: "#contact" },
];

export const HERO_IMAGE =
  "https://images.unsplash.com/photo-1615285103014-4ea152b01418?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA1NTN8MHwxfHNlYXJjaHwyfHxzY2FmZm9sZGluZyUyMHN0cnVjdHVyZSUyMHNpbGhvdWV0dGV8ZW58MHx8fHwxNzg0NjcyNTE1fDA&ixlib=rb-4.1.0&q=85";

export const STATS = [
  { value: "1,240", suffix: "+", label: "Structures Erected" },
  { value: "18", suffix: "YRS", label: "On The Tools" },
  { value: "240K", suffix: "T", label: "Steel Handled" },
  { value: "99.98", suffix: "%", label: "Safety Record" },
];

export const SERVICES = [
  {
    index: "01",
    slug: "access-scaffolding",
    title: "Access Scaffolding",
    desc: "Independent, tube-and-fitting and system scaffolds engineered for full-facade access on any elevation.",
    image:
      "https://images.unsplash.com/photo-1519143009590-e3800b9df468?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA4Mzl8MHwxfHNlYXJjaHwxfHxzY2FmZm9sZGluZyUyMGNvbnN0cnVjdGlvbiUyMHNpdGUlMjBzdGVlbCUyMHN0cnVjdHVyZXxlbnwwfHx8fDE3ODQ2NzI1NTV8MA&ixlib=rb-4.1.0&q=85",
    span: "lg:col-span-8",
  },
  {
    index: "02",
    slug: "shoring-propping",
    title: "Shoring & Propping",
    desc: "Load-bearing support and back-propping for slabs, beams and excavations.",
    span: "lg:col-span-4",
  },
  {
    index: "03",
    slug: "temporary-roofing",
    title: "Temporary Roofing",
    desc: "Weatherproof encapsulation systems keeping programmes on track through any season.",
    span: "lg:col-span-4",
  },
  {
    index: "04",
    slug: "industrial-formwork",
    title: "Industrial Formwork",
    desc: "Precision formwork and falsework for concrete pours across heavy-civil projects.",
    image:
      "https://images.pexels.com/photos/33914927/pexels-photo-33914927.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940",
    span: "lg:col-span-8",
  },
  {
    index: "05",
    slug: "safety-protection",
    title: "Edge & Safety Protection",
    desc: "Guardrails, netting and edge protection systems engineered to keep crews home safe.",
    span: "lg:col-span-6",
  },
  {
    index: "06",
    slug: "design-engineering",
    title: "Design & Engineering",
    desc: "In-house CSA-compliant design, load calculations and fully stamped drawings.",
    span: "lg:col-span-6",
  },
];

export const SERVICE_DETAILS = {
  "access-scaffolding": {
    index: "01",
    title: "Access Scaffolding",
    h1: "Access Scaffolding in Calgary & Alberta",
    tagline: "Full-facade access, engineered square and braced beyond code.",
    metaTitle: "Access Scaffolding Calgary, AB | Cretexa Scaffolding",
    metaDescription:
      "Independent, tube-and-fitting and system access scaffolding across Calgary and Alberta. CSA Z797 compliant, engineered and erected by Cretexa. Get a quote.",
    image:
      "https://images.unsplash.com/photo-1646608220368-c604d8e8130f?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA4Mzl8MHwxfHNlYXJjaHw0fHxzY2FmZm9sZGluZyUyMGNvbnN0cnVjdGlvbiUyMHNpdGUlMjBzdGVlbCUyMHN0cnVjdHVyZXxlbnwwfHx8fDE3ODQ2NzI1NTV8MA&ixlib=rb-4.1.0&q=85",
    intro:
      "Cretexa designs and erects access scaffolding for commercial, residential and industrial projects throughout Calgary and Alberta. From single-lift facade access to complex multi-level birdcages, every structure is built to CSA Z797, plumb, tied and inspected before a single boot lands on a board.",
    capabilities: [
      "Independent & putlog scaffolds for full-facade access",
      "Tube-and-fitting for irregular and heritage elevations",
      "System scaffold for rapid, repeatable commercial builds",
      "Mobile & static towers for interior fit-out",
      "Loading bays, hoist towers and pedestrian gantries",
      "Weekly statutory inspections and tag management",
    ],
    sectors: ["Commercial Construction", "High-Rise Residential", "Heritage Restoration", "Institutional & Civic"],
  },
  "shoring-propping": {
    index: "02",
    title: "Shoring & Propping",
    h1: "Shoring & Propping in Calgary & Alberta",
    tagline: "Load paths carried with certainty — from slab to excavation.",
    metaTitle: "Shoring & Propping Calgary, AB | Cretexa Scaffolding",
    metaDescription:
      "Engineered shoring, back-propping and excavation support across Calgary and Alberta. Load calculations and stamped drawings by Cretexa. Request a quote.",
    image:
      "https://images.pexels.com/photos/901941/pexels-photo-901941.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940",
    intro:
      "When a structure needs to carry load before it can carry itself, Cretexa provides engineered shoring and propping across Alberta. We calculate every load path and supply stamped drawings for slab support, back-propping and excavation shoring on heavy-civil and commercial sites.",
    capabilities: [
      "Slab and beam back-propping to engineered layouts",
      "Heavy-duty shoring towers for high-load applications",
      "Excavation and trench support systems",
      "Needle and flying shores for facade retention",
      "Load calculations with stamped engineering drawings",
      "Temporary works coordination and sign-off",
    ],
    sectors: ["Heavy Civil", "Infrastructure & Bridges", "Commercial Concrete", "Demolition & Retention"],
  },
  "temporary-roofing": {
    index: "03",
    title: "Temporary Roofing",
    h1: "Temporary Roofing & Encapsulation in Alberta",
    tagline: "Keep the weather out and the programme on track — all winter.",
    metaTitle: "Temporary Roofing Calgary, AB | Cretexa Scaffolding",
    metaDescription:
      "Weatherproof temporary roofing and shrink-wrap encapsulation for Alberta's climate. Keep work moving through snow and rain with Cretexa. Get a quote.",
    image:
      "https://images.unsplash.com/photo-1713593930871-e21d7f9ef4a1?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA4Mzl8MHwxfHNlYXJjaHwyfHxzY2FmZm9sZGluZyUyMGNvbnN0cnVjdGlvbiUyMHNpdGUlMjBzdGVlbCUyMHN0cnVjdHVyZXxlbnwwfHx8fDE3ODQ2NzI1NTV8MA&ixlib=rb-4.1.0&q=85",
    intro:
      "Alberta weather does not wait for your schedule. Cretexa's temporary roofing and encapsulation systems create a fully weatherproof envelope so trades keep working through snow, rain and wind — protecting both the build and the programme.",
    capabilities: [
      "Aluminium temporary roof systems (keder & beam)",
      "Shrink-wrap encapsulation and containment",
      "Monoflex / sheeted scaffold enclosures",
      "Heated and hoarded work environments",
      "Wind-load engineered for prairie conditions",
      "Rapid install and strike to suit trade sequencing",
    ],
    sectors: ["Winter Construction", "Refurbishment", "Roof Replacement", "Environmental Containment"],
  },
  "industrial-formwork": {
    index: "04",
    title: "Industrial Formwork",
    h1: "Industrial Formwork & Falsework in Alberta",
    tagline: "Precision moulds for concrete that has to be right the first time.",
    metaTitle: "Industrial Formwork & Falsework Calgary, AB | Cretexa",
    metaDescription:
      "Engineered formwork and falsework for concrete pours across Calgary and Alberta's heavy-civil and industrial projects. CSA S269 compliant. Request a quote.",
    image:
      "https://images.pexels.com/photos/33914927/pexels-photo-33914927.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940",
    intro:
      "Cretexa supplies and erects formwork and falsework for concrete construction across Alberta, engineered to CSA S269. From suspended slabs to deep foundations and industrial structures, we deliver the moulds and support that make precision pours possible.",
    capabilities: [
      "Wall, column and suspended slab formwork",
      "Falsework towers for high-load concrete support",
      "Climbing and jump-form for vertical structures",
      "Bespoke formwork for complex geometries",
      "CSA S269 engineered design and drawings",
      "Pour sequencing and strike scheduling",
    ],
    sectors: ["Heavy Civil", "Industrial Plants", "Water & Wastewater", "Transport Infrastructure"],
  },
  "safety-protection": {
    index: "05",
    title: "Edge & Safety Protection",
    h1: "Edge & Safety Protection in Calgary & Alberta",
    tagline: "Everyone goes home. Non-negotiable.",
    metaTitle: "Edge & Fall Protection Calgary, AB | Cretexa Scaffolding",
    metaDescription:
      "Guardrails, safety netting and edge protection systems engineered to Alberta OH&S. Keep crews safe at height with Cretexa. Get a quote.",
    image:
      "https://images.unsplash.com/photo-1552879890-3a06dd3a06c2?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NTYxODd8MHwxfHNlYXJjaHw0fHxjb25zdHJ1Y3Rpb24lMjB3b3JrZXJzJTIwc2FmZXR5JTIwaW5kdXN0cmlhbHxlbnwwfHx8fDE3ODQ2NzI1NTV8MA&ixlib=rb-4.1.0&q=85",
    intro:
      "Working at height carries the highest risk on any site. Cretexa engineers edge and fall protection to Alberta Occupational Health & Safety standards — guardrails, netting and access controls that keep crews safe without slowing them down.",
    capabilities: [
      "Perimeter guardrail and toe-board systems",
      "Debris and personnel safety netting",
      "Stair towers and safe access routes",
      "Roof edge protection and man-safe systems",
      "Public protection fans and gantries",
      "OH&S compliant inspection regimes",
    ],
    sectors: ["All Construction Sectors", "Industrial Maintenance", "Public Realm", "Roofing"],
  },
  "design-engineering": {
    index: "06",
    title: "Design & Engineering",
    h1: "Scaffold Design & Engineering in Alberta",
    tagline: "Stamped drawings and load calcs that pass inspection first time.",
    metaTitle: "Scaffold Design & Engineering Calgary, AB | Cretexa",
    metaDescription:
      "In-house CSA-compliant scaffold and temporary works design, load calculations and stamped engineering drawings across Alberta. Talk to Cretexa's engineers.",
    image:
      "https://images.unsplash.com/photo-1531834685032-c34bf0d84c77?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NTYxODd8MHwxfHNlYXJjaHwyfHxjb25zdHJ1Y3Rpb24lMjB3b3JrZXJzJTIwc2FmZXR5JTIwaW5kdXN0cmlhbHxlbnwwfHx8fDE3ODQ2NzI1NTV8MA&ixlib=rb-4.1.0&q=85",
    intro:
      "Every complex structure starts on the drawing board. Cretexa's in-house engineering team produces CSA-compliant temporary works designs, load calculations and fully stamped drawings — so your scaffold, shoring or formwork is signed off and inspection-ready before it is built.",
    capabilities: [
      "TG-equivalent CSA Z797 scaffold design",
      "Load path and structural calculations",
      "Stamped engineering drawings for permits",
      "Temporary works coordination (TWC)",
      "3D modelling for complex access",
      "Method statements and risk assessments",
    ],
    sectors: ["Complex Access", "High-Load Applications", "Permit Submissions", "Design-and-Build"],
  },
};

export const PROJECTS = [
  {
    id: "meridian",
    name: "Meridian Tower",
    location: "Toronto, ON",
    scale: "48,000 m²",
    tonnage: "3,100 T",
    year: "2024",
    image:
      "https://images.unsplash.com/photo-1670846112333-ca9115b38b18?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA1NTN8MHwxfHNlYXJjaHw0fHxzY2FmZm9sZGluZyUyMHN0cnVjdHVyZSUyMHNpbGhvdWV0dGV8ZW58MHx8fHwxNzg0NjcyNTE1fDA&ixlib=rb-4.1.0&q=85",
    span: "lg:col-span-7",
  },
  {
    id: "foundry",
    name: "The Foundry",
    location: "Vancouver, BC",
    scale: "Heritage Restoration",
    tonnage: "890 T",
    year: "2023",
    image:
      "https://images.pexels.com/photos/11831530/pexels-photo-11831530.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940",
    span: "lg:col-span-5",
  },
  {
    id: "harbour",
    name: "Harbour Viaduct",
    location: "Montréal, QC",
    scale: "Marine Access",
    tonnage: "2,240 T",
    year: "2023",
    image:
      "https://images.unsplash.com/photo-1664662568348-24b1482b6354?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA4Mzl8MHwxfHNlYXJjaHwzfHxzY2FmZm9sZGluZyUyMGNvbnN0cnVjdGlvbiUyMHNpdGUlMjBzdGVlbCUyMHN0cnVjdHVyZXxlbnwwfHx8fDE3ODQ2NzI1NTV8MA&ixlib=rb-4.1.0&q=85",
    span: "lg:col-span-5",
  },
  {
    id: "vertex",
    name: "Vertex Refinery",
    location: "Aberdeen, UK",
    scale: "Industrial Shutdown",
    tonnage: "4,600 T",
    year: "2022",
    image:
      "https://images.pexels.com/photos/33998571/pexels-photo-33998571.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940",
    span: "lg:col-span-7",
  },
];

export const MANIFESTO = [
  {
    number: "01",
    title: "The Foundation",
    body: "Every structure begins below the surface. We survey, calculate and stamp every load path before a single standard leaves the yard. Nothing is improvised.",
  },
  {
    number: "02",
    title: "The Frame",
    body: "Steel is honest. It carries exactly what it is asked to carry. We build frames that respect that honesty — square, plumb, and braced beyond code.",
  },
  {
    number: "03",
    title: "The Standard",
    body: "CSA Z797, CSA S269, provincial OH&S. Compliance is the floor, not the ceiling. Our crews are drilled until the safe way is the only way they know.",
  },
  {
    number: "04",
    title: "The Legacy",
    body: "We are judged by what still stands. Cretexa structures are engineered to endure long after the last bolt is torqued and the crew has gone home.",
  },
];

export const PROJECT_TYPES = [
  "Access Scaffolding",
  "Shoring & Propping",
  "Temporary Roofing",
  "Industrial Formwork",
  "Edge & Safety Protection",
  "Design & Engineering",
  "Other",
];

export const FAQS = [
  {
    q: "What areas does Cretexa serve?",
    a: "We are based in Calgary, Alberta and provide scaffolding and construction services across Calgary, Edmonton, Red Deer, Fort McMurray and throughout Alberta. For larger industrial shutdowns and commercial projects we mobilize nationally across Canada.",
  },
  {
    q: "Is your scaffolding CSA compliant?",
    a: "Yes. Every Cretexa structure is erected to CSA Z797 (Access Scaffold), CSA S269 (Falsework & Formwork) and the applicable provincial Occupational Health & Safety regulations. Compliance is our baseline, not our ceiling.",
  },
  {
    q: "Do you provide engineered, stamped drawings?",
    a: "We do. Our in-house design team produces load calculations and fully stamped engineering drawings for access scaffolding, shoring, falsework and temporary works — so your project passes inspection the first time.",
  },
  {
    q: "What types of scaffolding and services do you offer?",
    a: "Access scaffolding, shoring and propping, temporary roofing and weather encapsulation, industrial formwork and falsework, edge and safety protection, plus full design and engineering. From single-lift access to complete refinery shutdowns.",
  },
  {
    q: "How do I get a quote?",
    a: "Fill out the Get-a-Quote form on this page with your scope, elevations and timeline. We return a costed, drawn-up temporary works proposal — no vague day rates — typically within one working day.",
  },
];

